

// import React, { useEffect, useState, useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { Carousel } from 'react-bootstrap';
// import Rightcontainer from '../Components/Rightcontainer';
// import Downloadbutton from '../Components/Downloadbutton';
// import DownloadPopup from '../Components/DownloadPopup';
// import Header from '../Components/Header';
// import { LanguageContext } from '../Components/LanguageContext';
// import { Sparkles, MessageCircle, Gamepad2, Radio, Play, Headphones, Award } from 'lucide-react';
// import 'bootstrap/dist/css/bootstrap.min.css';

// export default function Landing({ userAllData }) {
//   const [showDownloadPopup, setShowDownloadPopup] = useState(true);
//   const { language } = useContext(LanguageContext);

//   const siteSettingRaw = localStorage.getItem('sitSetting');
//   let siteSetting = {};
//   try {
//     siteSetting = siteSettingRaw && siteSettingRaw !== 'undefined' ? JSON.parse(siteSettingRaw) : {};
//   } catch (e) {
//     siteSetting = {};
//   }

//   const translations = {
//     hi: { Tournaments: 'प्रतियोगिता', playNow: 'अभी खेलें', support: 'सपोर्ट' },
//     en: { Tournaments: 'Tournaments', playNow: 'Play Now', support: 'Support' },
//   };

//   const t = translations[language] || translations.en;

//   return (
//     <>
//       {/* {showDownloadPopup && <DownloadPopup onClose={() => setShowDownloadPopup(false)} />} */}

//       <div className="landing-page-wrapper leftContainer mb_space mt-5 pt-5">
//         {/* Background Ambient Mesh Lights */}
//         <div className="landing-ambient glow-1"></div>
//         <div className="landing-ambient glow-2"></div>
//         <div className="landing-ambient glow-3"></div>

//         <div className="landing-main-container">

//           {/* ANNOUNCEMENT MESSAGE BANNER */}
//           {siteSetting?.site_message && (
//             <div className="announcement-card animate-fade-down">
//               <div className="announcement-content">
//                 <Sparkles className="sparkle-icon spin-sparkle" size={18} />
//                 <span>{siteSetting.site_message}</span>
//               </div>
//             </div>
//           )}

//           {/* GAMES SELECTION GRID */}
//           <section className="games-section-wrapper">
//             <div className="games-section-header">
//               <div className="header-left">
//                 <div className="section-icon-box">
//                   <Gamepad2 size={22} className="title-icon" />
//                 </div>
//                 <h3 className="section-title">Featured Games</h3>
//               </div>
//               <div className="live-count-badge">
//                 <Radio size={12} className="pulse-radio" />
//                 <span>ACTIVE LOBBIES</span>
//               </div>
//             </div>

//             {/* SIDE-BY-SIDE 2-COLUMN ROW (6-6 SPLIT) */}
//             <div className="games-grid-container two-cols">
//               {/* LUDO CLASSIC MANUAL CARD */}
//               <Link to="/Homepage/ludoClassicManual" className="game-card-link">
//                 <div className="game-card-box">
//                   <div className="card-top-bar">
//                     <div className="live-status-pill">
//                       <Radio size={12} className="pulse-radio" />
//                       <span>LIVE</span>
//                     </div>
//                     <span className="game-badge-mini">
//                       <Award size={12} /> Classic
//                     </span>
//                   </div>

//                   <div className="game-card-img-wrap">
//                     <img
//                       src="./mainimage/ludoclassic.png"
//                       alt="Ludo Classic"
//                       className="game-cover-img"
//                     />
//                   </div>

            
//                 </div>
//               </Link>

//               {/* LUDO WHATSAPP SUPPORT CARD */}
//               {siteSetting?.whatsappSupport && (
//                 <a
//                   href={siteSetting.whatsappSupport}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="game-card-link"
//                 >
//                   <div className="game-card-box support-card-variant">
//                     <div className="card-top-bar">
//                       <div className="live-status-pill red-live">
//                         <Radio size={12} className="pulse-radio" />
//                         <span>LIVE</span>
//                       </div>
//                       <span className="game-badge-mini gold">
//                         <Headphones size={12} /> 24/7 Help
//                       </span>
//                     </div>

//                     <div className="game-card-img-wrap">
//                       <img
//                         src="./mainimage/ludosupport.png"
//                         alt="Ludo Support"
//                         className="game-cover-img"
//                       />
//                     </div>

//                     <div className="card-hover-overlay">
//                       <span className="play-btn-pill gold">
//                         <Headphones size={14} />
//                         {t.support}
//                       </span>
//                     </div>
//                   </div>
//                 </a>
//               )}
//             </div>
//           </section>
//           {/* 3. EXPLORE OUR SERVICES Section */}
//           <div className="section-divider d-flex align-items-center my-4">
//             <div className="flex-grow-1 border-top "></div>
//             <span className="mx-3 font-weight-bold" style={{ letterSpacing: '1px', fontSize: '18px', color: '#000' }}>
//               EXPLORE OUR SERVICES
//             </span>
//             <div className="flex-grow-1 border-top bordersecondarys"></div>
//           </div>


//           {/* DOWNLOAD APP BUTTON SECTION */}
//           <div className="download-button-wrapper">
//             <Downloadbutton />
//           </div>

//         </div>
//       </div>

//       {/* WHATSAPP SUPPORT FLOATING ACTION */}
//       {siteSetting?.whatsappSupport && (
//         <div className="floating-social-btn whatsapp-floating">
//           <a href={siteSetting.whatsappSupport} target="_blank" rel="noreferrer">
//           </a>
//         </div>
//       )}

//       {/* RIGHT SIDEBAR ON DESKTOP */}
//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </>
//   );
// }




import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Rightcontainer from '../Components/Rightcontainer';
import Downloadbutton from '../Components/Downloadbutton';
import DownloadPopup from '../Components/DownloadPopup';
import Header from '../Components/Header';
import { LanguageContext } from '../Components/LanguageContext';
import { Sparkles, Gamepad2, Radio, Headphones, Star, Users, ChevronRight } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Landing({ userAllData }) {
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);
  const { language } = useContext(LanguageContext);

  // Trigger Download Popup every time the component mounts/user visits this page
  useEffect(() => {
    setShowDownloadPopup(true);
  }, []);

  const siteSettingRaw = localStorage.getItem('sitSetting');
  let siteSetting = {};
  try {
    siteSetting = siteSettingRaw && siteSettingRaw !== 'undefined' ? JSON.parse(siteSettingRaw) : {};
  } catch (e) {
    siteSetting = {};
  }

  const translations = {
    hi: { Tournaments: 'प्रतियोगिता', playNow: 'अभी खेलें', support: 'सपोर्ट' },
    en: { Tournaments: 'Tournaments', playNow: 'Play Now', support: 'Support' },
  };

  const t = translations[language] || translations.en;

  return (
    <>
      {/* <Header user={userAllData} /> */}

    

      <div className="ce-landing-wrapper leftContainer mb_space mt-5 pt-5">
        <div className="ce-landing-container">

          {/* 1. Welcome & Announcement Banner Card */}
          <div className="ce-welcome-banner">
            <div className="ce-welcome-header">
              <Star size={20} className="ce-star-icon" />
              <h2>Welcome, <span>Play and Enjoy</span></h2>
            </div>
            <p className="ce-notice-text">
              {siteSetting?.site_message ||
                "डिपॉजिट केवल खुद के अकाउंट से करें QR को फॉरवर्ड करके फ्रॉड का पेमेंट करवाने वाले बंदे की आईडी को तुरंत ब्लॉक किया जाएगा बिल्कुल भी नहीं खोला जाएगा whatsapp:- 6375829599"}
            </p>
          </div>

          {/* 2. Games Section */}
          <section className="ce-games-section">
            <div className="ce-games-header">
              <div className="ce-header-icon-box">
                <Gamepad2 size={18} />
              </div>
              <div className="ce-header-titles">
                <h3>GAMES</h3>
                <p>Choose a mode</p>
              </div>
            </div>

            {/* 2-Column Game Cards Grid */}
            <div className="ce-games-grid">
              
              {/* LUDO CLASSIC MANUAL CARD */}
              <Link to="/Homepage/ludoClassicManual" className="ce-game-card-link">
                <div className="ce-game-card">
                  <div className="ce-card-badge-top">
                    <span className="ce-live-pill">
                      <span className="ce-live-dot"></span>
                      LIVE
                    </span>
                  </div>

                  <div className="ce-game-cover-box">
                    <img
                      src="./mainimage/ludoclassic.png"
                      alt="LUDO CLASSIC"
                      className="ce-game-img"
                    />
                  </div>

                  <div className="ce-card-footer-title">
                    <span className="ce-card-footer-titles">LUDO CLASSIC</span>
                  </div>
                </div>
              </Link>

              {/* LUDO SUPPORT / COMING SOON CARD */}
              {siteSetting?.whatsappSupport ? (
                <a
                  href={siteSetting.whatsappSupport}
                  target="_blank"
                  rel="noreferrer"
                  className="ce-game-card-link"
                >
                  <div className="ce-game-card">
                    <div className="ce-card-badge-top">
                      <span className="ce-coming-pill">24/7 SUPPORT</span>
                    </div>

                    <div className="ce-game-cover-box">
                      <img
                        src="./mainimage/ludosupport.png"
                        alt="1 GOTI LUDO"
                        className="ce-game-img"
                      />
                    </div>

                    <div className="ce-card-footer-title">
                      <span className="ce-card-footer-titles">Support</span>
                    </div>
                  </div>
                </a>
              ) : (
                <div className="ce-game-card disabled-card">
                  <div className="ce-card-badge-top">
                    <span className="ce-coming-pill">COMING SOON</span>
                  </div>

                  <div className="ce-game-cover-box">
                    <img
                      src="./mainimage/ludosupport.png"
                      alt="support"
                      className="ce-game-img"
                    />
                  </div>

                  <div className="ce-card-footer-title">
                    <h4>support</h4>
                  </div>
                </div>
              )}

            </div>
          </section>

          {/* 3. Refer & Earn Banner Card */}
          <Link to="/refer" className="ce-refer-banner-link">
            <div className="ce-refer-banner-card">
              <div className="ce-refer-left">
                <div className="ce-refer-icon-box">
                  <Users size={20} />
                </div>
                <div className="ce-refer-info">
                  <span className="ce-refer-tag">REFER & EARN</span>
                  <h3>1% COMMISSION</h3>
                  <p>Invite friends and earn</p>
                </div>
              </div>

              <div className="ce-refer-arrow-circle">
                <ChevronRight size={18} />
              </div>
            </div>
          </Link>

          {/* Download App Section */}
          <div className="ce-download-area mt-4">
            <Downloadbutton />
          </div>

        </div>
      </div>

      {/* Floating WhatsApp Action */}
      {siteSetting?.whatsappSupport && (
        <div className="floating-social-btn whatsapp-floating">
          <a href={siteSetting.whatsappSupport} target="_blank" rel="noreferrer">
            <Headphones size={22} />
          </a>
        </div>
      )}

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}